module.exports = __webpack_public_path__ + "img/07_2.d1b0ed65.png";